module.exports = __webpack_public_path__ + "static/img/register.c6b229c6.png";